import { HistoricalVisitSimple } from '@dreryk/egabinet-visit-frontend-api';

import { HistoricalVisitSimpleWithConfidentialDetails } from './types';

export const isHistoricalVisitSimpleWithConfidentialDetails = (
   visit: HistoricalVisitSimple
): visit is HistoricalVisitSimpleWithConfidentialDetails => {
   return Boolean(visit.confidentialDetails);
};
